import * as types from '../../action-types';
import { getSinglePayment as initialState } from "../../initialState";

const getSinglePayment = (state=initialState, action) => {
  switch (action.type) {
    case types.GET_SINGLE_PAYMENT_START:
      return {
        ...state,
        isLoading: true
      };
    case types.GET_SINGLE_PAYMENT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        data: action.payload
      };
    case types.GET_SINGLE_PAYMENT_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };
    case types.GET_SINGLE_PAYMENT_CLEANUP:
      return {
        ...state,
        isLoading: false,
        isSuccessful: false,
        error: null
      };
    default:
      return state;
  }
}

export default getSinglePayment;
